import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

var _methods;

import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import KeyCode from '../_util/KeyCode';
import { getComponentFromProp, getOptionProps, isValidElement, hasProp, getListeners, filterEmpty } from '../_util/props-util';
import { arrayTreeFilter, convertTreeToEntities, formatSelectorValue, updateCheckedNodes, conductCheck, formatInternalValue, getFilterTree, getArrayTreeDeep, updateSelectorNodes, flattenTreeNodes, keyBy } from '../cascader/util';
import CascaderPropTypes from '../cascader/CascaderPropTypes';
// import MaxTagPlaceholder from '../cascader/MaxTagPlaceholder';
// import SelectFilter from '../cascader/SelectFilter';
import SearchInput from '../cascader/SearchInput';
import Selector from '../cascader/Selector';
import SelectTag from '../cascader/SelectTag';
import SelectPopup from '../cascader/SelectPopup';
import Checkbox from '../cascader/Checkbox';
import Trigger from '../vc-trigger';
import Tabs from '../tabs';
import Icon from '../icon';
import Spin from '../spin';
import Button from '../button';
import message from '../message';
import { cloneElement } from '../_util/vnode';
import { createRef } from '../vc-tree-select/src/util';
import Menus from './Menus';
import { debounce, cloneDeep } from 'lodash';
import { SHOW_CHILD } from '../cascader/strategies';
import { BUILT_IN_PLACEMENTS } from '../cascader/placement';
import LocaleReceiver from '../locale-provider/LocaleReceiver';

var SelectTrigger = {
  mixins: [BaseMixin],
  props: _extends({}, CascaderPropTypes, {
    prefixCls: PropTypes.string.def('rc-cascader'),
    selectPrefixCls: PropTypes.string.def('rc-select'),
    inputPrefixCls: PropTypes.string.def('rc-input'),
    builtinPlacements: PropTypes.object.def(BUILT_IN_PLACEMENTS),
    treeData: PropTypes.array,
    expandIcon: PropTypes.any,
    loadingIcon: PropTypes.any,
    removeIcon: PropTypes.any,
    loadData: PropTypes.func
  }),
  inject: {
    localeData: { 'default': function _default() {
        return {};
      } }
  },
  provide: function provide() {
    return {
      Cascader: {
        onSelectorFocus: this.onSelectorFocus,
        onSelectorBlur: this.onSelectorBlur,
        onSelectorKeyDown: this.onComponentKeyDown,
        onSelectorClear: this.onSelectorClear,
        onMultipleSelectorRemove: this.onMultipleSelectorRemove,

        onMenuSelect: this.onMenuSelect,
        onMenuCheck: this.onMenuCheck,

        onSearchInputChange: this.onSearchInputChange,
        onSearchInputKeyDown: this.onSearchInputKeyDown,
        onSearchClear: this.onSearchClear,
        onFastFinderChange: this.onFastFinderChange,

        defaultValidatorFn: this.defaultValidatorFn
      }
    };
  },
  data: function data() {
    this.needSyncKeys = {};
    var initialValue = [];
    var _$props = this.$props,
        value = _$props.value,
        defaultValue = _$props.defaultValue,
        defaultActiveKey = _$props.defaultActiveKey,
        open = _$props.open,
        defaultOpen = _$props.defaultOpen,
        visibleEndIndex = _$props.visibleEndIndex,
        popupPlacement = _$props.popupPlacement;

    if (hasProp(this, 'value')) {
      initialValue = value;
    } else if (hasProp(this, 'defaultValue')) {
      initialValue = defaultValue;
    }
    var activeValue = initialValue;

    var state = {
      // Used for select
      sActiveValue: activeValue, // active value
      sActiveOptions: [], // active option
      sValue: activeValue, // stored value
      _activeTabKey: defaultActiveKey,
      _visibleEndIndex: visibleEndIndex,
      _popupPlacement: popupPlacement,

      // Used for check
      _prevProps: {},
      _treeNodes: [],
      _fastFinderOption: [],
      _filteredTreeNodes: undefined,
      _keyEntities: new Map(),
      _open: open || defaultOpen,
      _init: true,
      _searchValue: '',
      _checkedKeys: [], // 全选key
      _halfCheckedKeys: [], // 半选key
      _valueList: [], // 当前数据源下的已选项，可能只有属性{key|value}
      _missValueList: [], // 其他数据源下的已选项
      _selectorValueList: [], // 选择器已选项
      _selectedTagList: [] // 底部标签栏已选项
    };
    return _extends({}, state);
  },

  computed: {
    deep: function deep() {
      var _$data = this.$data,
          treeNodes = _$data._treeNodes,
          activeTabKey = _$data._activeTabKey;
      var _$props2 = this.$props,
          tabs = _$props2.tabs,
          multiple = _$props2.multiple,
          showCheckAll = _$props2.showCheckAll;

      var activeTreeNodes = tabs && tabs.length > 0 || multiple && showCheckAll ? (treeNodes[activeTabKey] || {}).children || [] : treeNodes;
      var deep = getArrayTreeDeep(activeTreeNodes);
      return deep;
    },
    maxDeep: function maxDeep() {
      var treeNodes = this.$data._treeNodes;
      var tabs = this.$props.tabs;


      if (tabs && tabs.length > 0) {
        return treeNodes.reduce(function (max, node) {
          return Math.max(max, getArrayTreeDeep(node.children));
        }, 0);
      } else {
        return this.deep;
      }
    }
  },
  watch: {
    open: function open(_open) {
      this.setState({ _open: _open });
    },
    '$data._open': function $data_open(open) {
      var _$props3 = this.$props,
          visibleEndIndex = _$props3.visibleEndIndex,
          treeData = _$props3.treeData,
          tabs = _$props3.tabs;
      var _$data2 = this.$data,
          selectedTagList = _$data2._selectedTagList,
          treeNodes = _$data2._treeNodes;

      this.setState({
        _open: open,
        _visibleEndIndex: visibleEndIndex,
        _popupPlacement: this.getPopupPlacement()
      });
      if (treeData.length > 0) {
        // const startTime = Date.now();
        this.reset({ valueRefresh: true });

        // 弹出后，激活tab
        if (selectedTagList[0] && tabs && tabs.length) {
          var _ref = selectedTagList[0] || {},
              key = _ref.key;

          var tabKey = key.split('-')[0];
          var index = treeNodes.findIndex(function (n) {
            return n.key === tabKey;
          });
          this.setState({ _activeTabKey: index });
        }
        // console.log('open', Date.now() - startTime);
      }
    },

    treeData: {
      handler: function handler(val, oldVal) {
        if ((!val || val.length === 0) && oldVal === undefined) return;
        this.createData(val, { treeRefresh: true, valueRefresh: true });
      },

      immediate: true,
      deep: true
    },
    value: function value(val, oldVal) {
      if ((!val || val.length === 0) && oldVal === undefined) return;
      var treeData = this.$props.treeData;

      this.needSyncKeys['value'] = true;
      this.createData(treeData, { valueRefresh: true });
    },
    multiple: function multiple() {
      var treeData = this.$props.treeData;

      this.createData(treeData);
    },
    searchValue: function searchValue() {
      this.setState(this.getDerivedState(getOptionProps(this), this.$data));
      this.buildFilteredTreeNodes();
    }
  },
  created: function created() {
    this.inputRef = createRef();
    this.searchRef = createRef();
    this.menuRef = createRef();
    this.triggerRef = createRef();
    this.popupRef = createRef();
  },

  methods: (_methods = {
    createData: function createData(data) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { treeRefresh: true };

      // const startTime = Date.now();
      this.needSyncKeys = {};
      var props = getOptionProps(this);
      var treeNodes = this.updateTreeData(data);
      var entitiesMap = convertTreeToEntities(treeNodes, props);

      // console.log('entitiesMap', entitiesMap);
      var newState = this.$data;
      newState._treeNodes = Object.freeze(treeNodes);
      newState._posEntities = Object.freeze(entitiesMap.posEntities);
      newState._valueEntities = Object.freeze(entitiesMap.valueEntities);
      newState._keyEntities = Object.freeze(entitiesMap.keyEntities);
      // console.log('createData', newState);
      this.setState(newState);

      if (refresh.treeRefresh) {
        // when has props `tabs`, should generate the new entity
        var _$props4 = this.$props,
            defaultFilterValue = _$props4.defaultFilterValue,
            filterFn = _$props4.filterFn;

        this._buildFilteredTreeNodes(defaultFilterValue, filterFn);
        // console.log('createData', Date.now() - startTime);
      }
      // 重置时初始化
      this.setState(this.getDerivedState(getOptionProps(this), this.$data, refresh));
    },
    getDerivedState: function getDerivedState(nextProps, prevState) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        treeRefresh: false,
        valueRefresh: false,
        valueReset: false
      },
          treeRefresh = _ref2.treeRefresh,
          valueRefresh = _ref2.valueRefresh,
          valueReset = _ref2.valueReset;

      // const startTime = Date.now();
      var unrelated = nextProps.unrelated,
          multiple = nextProps.multiple,
          showConfirm = nextProps.showConfirm,
          tabGroup = nextProps.tabGroup;
      var _prevState$_prevProps = prevState._prevProps,
          prevProps = _prevState$_prevProps === undefined ? {} : _prevState$_prevProps,
          valueList = prevState._valueList;
      var treeNodes = prevState._treeNodes,
          _prevState$_keyEntiti = prevState._keyEntities,
          keyEntities = _prevState$_keyEntiti === undefined ? new Map() : _prevState$_keyEntiti,
          valueEntities = prevState._valueEntities;

      var newState = {
        _prevProps: _extends({}, nextProps),
        _valueList: valueList,
        _init: false
      };
      if (!treeNodes || treeNodes.length === 0) return newState;

      var self = this;
      // Process the state when props updated
      function processState(propName, updater) {
        // console.log(123, propName, prevProps[propName], nextProps[propName], prevProps[propName] !== nextProps[propName], self.needSyncKeys[propName]);
        if (prevProps[propName] !== nextProps[propName] || self.needSyncKeys[propName]) {
          updater(nextProps[propName], prevProps[propName]);
          return true;
        }
        return false;
      }

      if (prevState._init) {
        processState('defaultValue', function (propValue) {
          // console.log('defaultValue', propValue);
          newState._valueList = formatInternalValue(propValue, nextProps);
          valueRefresh = true;
        });
      }

      // propValue必须为['0-1-1']的结构
      processState('value', function (propValue) {
        // console.log('propValue', propValue);
        newState._valueList = formatInternalValue(propValue, nextProps);
        valueRefresh = true;
      });
      // value是否变更
      // console.log('valueRefresh:', valueRefresh, 'treeRefresh:', treeRefresh);

      // 初始化_valueList的值
      if (valueRefresh) {
        newState._valueList = formatInternalValue(nextProps.value || nextProps.defaultValue, nextProps);
      }

      if (valueReset) {
        newState._valueList = formatInternalValue(nextProps.resetValue, nextProps);
      }
      // console.log('_valueList', nextProps.value, newState._valueList);

      // 当value没有改变，但数据源改变时，强制把_valueList设置成_selectedTagList
      if (!valueRefresh && !valueReset && treeRefresh) {
        newState._valueList = [].concat(_toConsumableArray(prevState._selectedTagList));
      }
      // console.log(`_valueList`, newState._valueList);

      // Selector Value List
      var hasTabChange = false;
      var selectedTagList = [];
      if (valueRefresh || treeRefresh) {
        // Find out that value not exist in the tree
        var missValueList = [];
        // if (valueRefresh && !treeRefresh && open && multiple) {
        //   missValueList = [...prevState._selectedTagList];
        // }
        var filteredValueList = [];
        var keyList = [];

        // Get key by value
        // console.log('keyEntities', keyEntities);
        newState._valueList.forEach(function (wrapperValue) {
          var _wrapperValue = wrapperValue,
              key = _wrapperValue.key,
              value = _wrapperValue.value;

          var _ref3 = valueEntities[value] || {},
              _key = _ref3.key,
              node = _ref3.node;

          if (key !== _key) hasTabChange = true;

          /** 针对切换tab后有相同value值时，已选key作为路径会变更_key */
          var entity = keyEntities.get(key) || keyEntities.get(_key);

          if (entity) {
            keyList.push(entity.key);
            var props = entity.node;
            filteredValueList.push({
              key: props.key,
              value: props.value,
              label: props.label
            });
            return;
          }

          /** 切换tab后，当前页面不存在的已选项key值主动变更为_key */
          if (_key) {
            var dataRef = node.dataRef,
                rest = _objectWithoutProperties(node, ['dataRef']);

            wrapperValue = _extends({}, rest);
            wrapperValue.key = _key;
          }
          // If not match, it may caused by ajax load. We need keep this
          missValueList.push(wrapperValue);
        });
        newState._missValueList = missValueList;

        // We need calculate the value when tree is checked tree
        if (!unrelated) {
          // Calculate the keys need to be checked
          var _conductCheck = conductCheck(keyList, true, keyEntities),
              checkedKeys = _conductCheck.checkedKeys,
              halfCheckedKeys = _conductCheck.halfCheckedKeys;

          newState._checkedKeys = checkedKeys;
          newState._halfCheckedKeys = halfCheckedKeys;

          // Format value list again for internal usage
          newState._valueList = [];
          checkedKeys.map(function (key) {
            var entity = keyEntities.get(key);
            if (entity) {
              var props = keyEntities.get(key).node;
              newState._valueList.push({
                key: props.key,
                value: props.value,
                label: props.label
              });
            }
          });
        } else {
          newState._valueList = filteredValueList;
          newState._checkedKeys = newState._valueList.map(function (_ref4) {
            var key = _ref4.key;
            return key;
          });
        }
        // console.log('missValueList:', missValueList, '_valueList:', newState._valueList, 'keyList:', keyList);

        // Calculate the value list for `Selector` usage
        selectedTagList = formatSelectorValue(newState._valueList, nextProps, keyEntities, valueEntities) || [];
        var selectedTagListMap = keyBy(selectedTagList, 'key');
        selectedTagList = newState._valueList.map(function (_ref5) {
          var key = _ref5.key;
          return selectedTagListMap[key];
        }).filter(function (n) {
          return n;
        });
        newState._selectedTagList = updateCheckedNodes(prevState._selectedTagList, [].concat(_toConsumableArray(selectedTagList), missValueList));
        selectedTagList = [].concat(_toConsumableArray(newState._selectedTagList));
      }
      // console.log('_selectorValueList', prevState._selectedTagList, newState._selectedTagList);

      // Search value
      processState('searchValue', function (propValue) {
        newState._searchValue = propValue;
      });

      // when the props `showConfirm` is false, should submit to selector automatically
      if (valueRefresh || !showConfirm) {
        newState._selectorValueList = [].concat(_toConsumableArray(selectedTagList));
      } else if (tabGroup === 'dimension') {
        // when switch tabs, update selectorValueList by selectedValueList
        newState._selectorValueList = updateSelectorNodes(prevState._selectorValueList, selectedTagList);
      }
      // console.log('_selectorValueList', prevState._selectorValueList, newState._selectorValueList, newState._selectedTagList);

      if (treeRefresh) {
        if (hasTabChange) {
          var _ref6 = newState._selectedTagList[0] || {},
              key = _ref6.key,
              value = _ref6.value;

          var sValue = key || value;
          var activeValue = sValue ? ('' + sValue).split('-') : [];
          newState.sActiveValue = activeValue;
          newState.sActiveOptions = this.getActiveOptions(activeValue);
          if (!multiple) {
            newState.sValue = activeValue;
          }
          // console.log('activeValue', key, value, activeValue, newState.sActiveOptions);
        }
        // 当前没有选中项时，不应该清空已选值
        // if (!newState._valueList || newState._valueList.length === 0) {
        //   newState.sActiveValue = [];
        //   newState.sActiveOptions = [];
        //   newState.sValue = [];
        // }
      }
      // console.log('getDerivedState3', Date.now() - startTime);
      return newState;
    },
    getActiveOptions: function getActiveOptions(activeValue) {
      var treeNodes = this.$data._treeNodes;

      return arrayTreeFilter(treeNodes, function (o, level) {
        return '' + o.value === '' + activeValue[level];
      });
    },
    onMenuSelect: function onMenuSelect(node, menuIndex, e) {
      var _extends2;

      var key = node.key,
          value = node.value,
          label = node.label,
          children = node.children,
          rest = _objectWithoutProperties(node, ['key', 'value', 'label', 'children']);

      var _$props5 = this.$props,
          unrelated = _$props5.unrelated,
          fieldNames = _$props5.fieldNames,
          showConfirm = _$props5.showConfirm,
          multiple = _$props5.multiple;

      if (!node || node.disabled) return;
      if (multiple && (!children || !children.length)) return;

      var sActiveValue = this.$data.sActiveValue;

      sActiveValue = key.split('-');

      // // 处理showGroup减少一级的情况
      // if (showGroup && key && menuIndex === 1) {
      //   const parentValue = key.split('-').reverse()[1];
      //   sActiveValue[menuIndex - 1] = parentValue;
      // }
      var activeOptions = this.getActiveOptions(sActiveValue);

      var eventObj = {
        event: 'check',
        node: node,
        nativeEvent: e
      };
      this.__emit('check', _extends({}, eventObj, {
        node: _extends((_extends2 = {}, _defineProperty(_extends2, fieldNames.value, value), _defineProperty(_extends2, fieldNames.label, label), _extends2), rest)
      }));

      var newState = {};
      if (!multiple && (!children || children.length === 0)) {
        showConfirm || this.handleChange(activeOptions, { open: false }, e);
        newState.sValue = sActiveValue;
        // add e.type judgement to prevent `onChange` being triggered by mouseEnter
      } else if (!multiple && unrelated && (e.type === 'keydown' || e.type === 'click')) {
        showConfirm || this.handleChange(activeOptions, { open: false }, e);
        newState.sValue = sActiveValue;
      }
      newState.sActiveValue = sActiveValue;
      newState.sActiveOptions = activeOptions;
      //  not change the value by keyboard
      if (hasProp(this, 'value') || e.type === 'keydown' && e.keyCode !== KeyCode.ENTER) {
        delete newState.sValue;
      }
      this.setState(newState);
    },
    onMenuCheck: function onMenuCheck(node, isCheck, e) {
      var _extends3;

      var eventKey = node.key;
      // const startTime = Date.now();

      var _$props6 = this.$props,
          unrelated = _$props6.unrelated,
          fieldNames = _$props6.fieldNames;
      var _$data3 = this.$data,
          keyEntities = _$data3._keyEntities,
          oriCheckedKeys = _$data3._checkedKeys,
          oriHalfCheckedKeys = _$data3._halfCheckedKeys;


      var eventObj = {
        event: 'check',
        node: node,
        checked: isCheck,
        nativeEvent: e
      };

      var key = node.key,
          value = node.value,
          label = node.label,
          children = node.children,
          rest = _objectWithoutProperties(node, ['key', 'value', 'label', 'children']);

      this.__emit('check', _extends({}, eventObj, {
        node: _extends((_extends3 = {}, _defineProperty(_extends3, fieldNames.value, value), _defineProperty(_extends3, fieldNames.label, label), _extends3), rest)
      }));

      if (unrelated) {
        var checkedKeys = oriCheckedKeys.slice();
        var index = checkedKeys.indexOf(eventKey);
        if (isCheck) {
          if (index === -1) checkedKeys.push(eventKey);
        } else {
          if (index > -1) checkedKeys.splice(index, 1);
        }
        eventObj.checkedKeys = checkedKeys;
        this.setUncontrolledState({ _checkedKeys: checkedKeys });
      } else {
        var _conductCheck2 = conductCheck([eventKey], isCheck, keyEntities, {
          checkedKeys: oriCheckedKeys,
          halfCheckedKeys: oriHalfCheckedKeys
        }),
            _checkedKeys = _conductCheck2.checkedKeys,
            halfCheckedKeys = _conductCheck2.halfCheckedKeys;

        eventObj.checkedKeys = _checkedKeys;
        this.setUncontrolledState({
          _checkedKeys: _checkedKeys,
          _halfCheckedKeys: halfCheckedKeys
        });
      }

      var valueList = eventObj.checkedKeys.map(function (k) {
        var props = keyEntities.get(k).node;

        var key = props.key,
            value = props.value,
            label = props.label,
            children = props.children,
            rest = _objectWithoutProperties(props, ['key', 'value', 'label', 'children']);

        return _extends({
          key: key,
          value: value,
          label: label
        }, rest);
      });
      this.setUncontrolledState({
        _valueList: valueList
      });
      eventObj.valueList = valueList;
      this.selectedValueChange(eventObj);
    },
    selectedValueChange: function selectedValueChange(eventObj) {
      var showConfirm = this.$props.showConfirm;
      var _eventObj = eventObj,
          valueList = _eventObj.valueList,
          selectorValueList = _eventObj.selectorValueList,
          event = _eventObj.event,
          e = _eventObj.nativeEvent;
      var _$data4 = this.$data,
          keyEntities = _$data4._keyEntities,
          prevSelectedTagList = _$data4._selectedTagList,
          missValueList = _$data4._missValueList,
          open = _$data4._open;

      var props = getOptionProps(this);
      var disabled = props.disabled;

      if (disabled) return;

      // Format value by `unrelated`
      var selectedValueList = formatSelectorValue(valueList, props, keyEntities);
      // console.log('checkChange', prevSelectedTagList, selectedValueList, missValueList);
      var selectedTagList = updateCheckedNodes(prevSelectedTagList, [].concat(_toConsumableArray(selectedValueList), _toConsumableArray(missValueList)));

      var newState = { _selectedTagList: selectedTagList };
      this.setState(newState);

      eventObj = _extends({}, eventObj, {
        // missValueList,
        selectedTagList: selectedTagList
      });

      if (!showConfirm) {
        this.triggerChange(eventObj);
      } else if (event === 'delete') {
        this.handleChange([].concat(_toConsumableArray(selectorValueList)), { open: open }, e);
      }
    },
    setTagList: function setTagList(selectedTagList) {
      var newState = { _selectedTagList: selectedTagList };
      this.setState(newState);
    },
    triggerChange: function triggerChange(eventObj) {
      var open = this.$data._open;

      var props = getOptionProps(this);
      var valueList = eventObj.valueList,
          selectedTagList = eventObj.selectedTagList,
          e = eventObj.nativeEvent;

      if (!('value' in props)) {
        var newState = {
          _valueList: valueList,
          _selectorValueList: selectedTagList
        };

        // if (searchValue && !unrelated) {
        //   newState._searchHalfCheckedKeys = getHalfCheckedKeys(valueList, valueEntities);
        // }

        this.setState(newState);
      }

      // Only do the logic when `onChange` function provided
      if (getListeners(this).change) {
        var connectValueList = void 0;

        // Get value by mode
        if (this.multiple) {
          connectValueList = [].concat(_toConsumableArray(selectedTagList));
        } else {
          connectValueList = selectedTagList.slice(0, 1);
        }
        this.handleChange(connectValueList, { open: open }, e);
      }
    },
    onItemDoubleClick: function onItemDoubleClick() {
      var unrelated = this.$props.unrelated;

      if (unrelated) {
        this.setPopupVisible(false);
      }
    },
    onCheckAllChange: function onCheckAllChange(node, checkAll, e) {
      var isCheck = !checkAll;
      this.onMenuCheck(node, isCheck, e);
    },
    onTagRemove: function onTagRemove(event, node) {
      var _extends4;

      event.stopPropagation();

      var _$data5 = this.$data,
          keyEntities = _$data5._keyEntities,
          missValueList = _$data5._missValueList,
          oriCheckedKeys = _$data5._checkedKeys,
          oriHalfCheckedKeys = _$data5._halfCheckedKeys,
          selectedTagList = _$data5._selectedTagList,
          selectorValueList = _$data5._selectorValueList;
      var eventKey = node.key;


      var props = getOptionProps(this);
      var unrelated = props.unrelated,
          disabled = props.disabled,
          fieldNames = props.fieldNames,
          max = props.max,
          min = props.min,
          validatorFn = props.validatorFn;

      var validator = validatorFn || this.defaultValidatorFn;
      if (disabled) return;
      if (validator && (max > 0 || min > 0) && !validator({
        selectedOptions: event.name ? selectorValueList : selectedTagList,
        checked: false,
        max: max,
        min: min
      })) {
        return;
      }

      var eventObj = {
        event: event.name ? 'delete' : 'remove',
        node: node,
        checked: false,
        nativeEvent: event
      };

      var key = node.key,
          value = node.value,
          label = node.label,
          children = node.children,
          rest = _objectWithoutProperties(node, ['key', 'value', 'label', 'children']);

      this.__emit('remove', _extends({}, eventObj, {
        node: _extends((_extends4 = {}, _defineProperty(_extends4, fieldNames.value, value), _defineProperty(_extends4, fieldNames.label, label), _extends4), rest)
      }));

      if (unrelated) {
        var checkedKeys = oriCheckedKeys.slice();
        var index = checkedKeys.indexOf(eventKey);
        if (index > -1) checkedKeys.splice(index, 1);
        eventObj.checkedKeys = checkedKeys;
        this.setUncontrolledState({ _checkedKeys: checkedKeys });
      } else {
        var _conductCheck3 = conductCheck([eventKey], false, keyEntities, {
          checkedKeys: oriCheckedKeys,
          halfCheckedKeys: oriHalfCheckedKeys
        }),
            _checkedKeys2 = _conductCheck3.checkedKeys,
            halfCheckedKeys = _conductCheck3.halfCheckedKeys;

        eventObj.checkedKeys = _checkedKeys2;
        this.setUncontrolledState({
          _checkedKeys: _checkedKeys2,
          _halfCheckedKeys: halfCheckedKeys
        });
      }

      var newValueList = eventObj.checkedKeys.map(function (key) {
        var props = keyEntities.get(key).node;
        return {
          key: props.key,
          value: props.value,
          label: props.label
        };
      });

      // when remove the selectorValueList, remove and save
      var newSelectorValueList = selectorValueList.filter(function (_ref7) {
        var key = _ref7.key;
        return key !== eventKey;
      });
      // console.log('newSelectorValueList', event.name, newSelectorValueList);

      // Some value user pass prop is not in the tree, we also need clean it
      var newMissValueList = missValueList.filter(function (_ref8) {
        var key = _ref8.key;
        return key !== eventKey;
      });

      this.setState({
        _valueList: newValueList,
        _missValueList: newMissValueList
      });
      if (event.name === 'delete') {
        this.setState({
          _selectorValueList: newSelectorValueList
        });
      }
      eventObj.valueList = newValueList;
      eventObj.selectorValueList = newSelectorValueList;
      this.selectedValueChange(eventObj);
    },
    onTabChange: function onTabChange(key) {
      var _$props7 = this.$props,
          defaultFilterValue = _$props7.defaultFilterValue,
          filterFn = _$props7.filterFn,
          visibleEndIndex = _$props7.visibleEndIndex;

      this.scrollToTop();
      this.setState({ _activeTabKey: key, _visibleEndIndex: visibleEndIndex });
      this._buildFilteredTreeNodes(defaultFilterValue, filterFn);
      this.__emit('tabChange', key);
    },
    onCancel: function onCancel() {
      this.setPopupVisible(false);
      this.__emit('cancel');
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { valueReset: true };
      var treeData = this.$props.treeData;

      this.createData(treeData, _extends({}, value, { treeRefresh: true }));
      this.setState({ _searchValue: '' });
      // setTimeout(() => this.onTabChange(0), 100);
    },
    onReset: function onReset(e) {
      this.reset();
      this.__emit('reset', e);
    },
    onConfirm: function onConfirm(e) {
      var _$props8 = this.$props,
          multiple = _$props8.multiple,
          max = _$props8.max,
          min = _$props8.min,
          validatorFn = _$props8.validatorFn;
      var _$data6 = this.$data,
          valueList = _$data6._valueList,
          selectedTagList = _$data6._selectedTagList,
          activeValue = _$data6.sActiveValue,
          activeOptions = _$data6.sActiveOptions;
      var defaultValidatorFn = this.defaultValidatorFn;


      var validator = validatorFn || defaultValidatorFn;
      if (validator && (max > 0 || min > 0) && !validator({
        selectedOptions: multiple ? selectedTagList : activeOptions.slice(-1),
        max: max,
        min: min
      })) {
        return;
      }

      var open = false;
      if (multiple) {
        var eventObj = {
          event: 'confirm',
          nativeEvent: e,
          valueList: valueList,
          selectedTagList: selectedTagList
        };
        this.setState({ sValue: valueList, _open: open });
        this.triggerChange(eventObj, open);
      } else {
        this.setState({ sValue: activeValue, _open: open });
        this.handleChange(activeOptions, { open: open }, e);
      }
    },
    defaultValidatorFn: function defaultValidatorFn(_ref9) {
      var selectedOptions = _ref9.selectedOptions,
          checked = _ref9.checked,
          min = _ref9.min,
          max = _ref9.max;

      var count = selectedOptions.length;
      var locale = LocaleReceiver.getLocale('Cascader', this.localeData);
      if (max > 0 && (checked === true && count >= max || checked === undefined && count > max)) {
        message.warning(('' + locale.max).replace('%s', max));
        return;
      } else if (min > 0 && (checked === false && count <= min || checked === undefined && count < min)) {
        message.warning(('' + locale.min).replace('%s', min));
        return;
      }
      return true;
    },
    onMultipleSelectorRemove: function onMultipleSelectorRemove(event, item) {
      event.name = true;
      this.onTagRemove(event, item);
    },
    onSelectorClear: function onSelectorClear(e) {
      e.stopPropagation();
      var _$props9 = this.$props,
          disabled = _$props9.disabled,
          max = _$props9.max,
          min = _$props9.min,
          validatorFn = _$props9.validatorFn;

      var validator = validatorFn || this.defaultValidatorFn;
      if (disabled) return;
      if (validator && (max > 0 || min > 0) && !validator({
        selectedOptions: new Array(min),
        checked: false,
        min: min
      })) {
        return;
      }

      var eventObj = {
        event: 'clear',
        nativeEvent: e,
        valueList: [],
        selectedTagList: []
      };
      this.setUncontrolledState({
        _valueList: [],
        _missValueList: [],
        _selectedTagList: [],
        _selectorValueList: []
      });
      this.triggerChange(eventObj);

      if (!this.isSearchValueControlled()) {
        this.setUncontrolledState({
          _searchValue: ''
        });
      }

      event.stopPropagation();
    },
    onSearchClear: function onSearchClear(e) {
      e.stopPropagation();
      var isSet = false;
      isSet = this.setUncontrolledState({
        _searchValue: ''
      });

      if (isSet) {
        this.buildFilteredTreeNodes('');
      }
    },
    setUncontrolledState: function setUncontrolledState(state) {
      var needSync = false;
      var newState = {};
      var props = getOptionProps(this);
      Object.keys(state).forEach(function (name) {
        if (name.replace('_', '') in props) return;
        needSync = true;
        newState[name] = state[name];
      });

      if (needSync) {
        this.setState(newState);
      }

      return needSync;
    },
    handleChange: function handleChange(options, setProps, e) {
      var _$props10 = this.$props,
          multiple = _$props10.multiple,
          fieldNames = _$props10.fieldNames,
          uniqueKey = _$props10.uniqueKey;

      var selected = multiple ? options : options.slice(-1);
      if (e.type !== 'keydown' || e.keyCode === KeyCode.ENTER) {
        this.__emit('change', selected.map(function (item) {
          return uniqueKey ? item.key : item.value;
        }), selected.map(function (_ref10) {
          var _extends5;

          var key = _ref10.key,
              value = _ref10.value,
              label = _ref10.label,
              children = _ref10.children,
              rest = _objectWithoutProperties(_ref10, ['key', 'value', 'label', 'children']);

          return _extends((_extends5 = {}, _defineProperty(_extends5, fieldNames.value, uniqueKey ? key : value), _defineProperty(_extends5, fieldNames.label, label), _extends5), rest);
        }));
        this.setPopupVisible(setProps.open);
      }
    },
    onDropdownVisibleChange: function onDropdownVisibleChange(open) {
      this.setPopupVisible(open);
    },
    setPopupVisible: function setPopupVisible(open) {
      if (!hasProp(this, 'open')) {
        this.setState({ _open: open });
      }
      if (open && !this._open && !this.multiple) {
        this.setState({ sActiveValue: this.sValue });
      }
      this.__emit('popupVisibleChange', open);
    },
    onSearchInputChange: function onSearchInputChange(e) {
      var value = e.target.value;
      this.__emit('update:searchValue', value);
      this.__emit('search', value);

      var isSet = false;
      if (!this.isSearchValueControlled()) {
        isSet = this.setUncontrolledState({
          _searchValue: value
        });
      }

      if (isSet) {
        this.buildFilteredTreeNodes();
      }
    }
  }, _defineProperty(_methods, 'onSearchClear', function onSearchClear(e) {
    e.stopPropagation();
    var value = '';
    this.__emit('update:searchValue', value);
    this.__emit('search', value);

    var isSet = false;
    if (!this.isSearchValueControlled()) {
      isSet = this.setUncontrolledState({
        _searchValue: ''
      });
    }
    if (isSet) {
      this.buildFilteredTreeNodes();
    }
  }), _defineProperty(_methods, 'isSearchValueControlled', function isSearchValueControlled() {
    var props = getOptionProps(this);
    if ('searchValue' in props) return true;
  }), _defineProperty(_methods, 'buildFilteredTreeNodes', debounce(function () {
    var defaultFilterValue = this.defaultFilterValue,
        filterFn = this.filterFn;

    this._buildFilteredTreeNodes(defaultFilterValue, filterFn);
  }, 400)), _defineProperty(_methods, '_buildFilteredTreeNodes', function _buildFilteredTreeNodes(value, customFilterFn) {
    var _$props11 = this.$props,
        filterTreeNode = _$props11.filterTreeNode,
        showGroup = _$props11.showGroup,
        propTabs = _$props11.tabs,
        tabGroup = _$props11.tabGroup,
        unrelated = _$props11.unrelated,
        multiple = _$props11.multiple,
        showCheckAll = _$props11.showCheckAll,
        showCheckedStrategy = _$props11.showCheckedStrategy,
        maxTreeNodes = _$props11.maxTreeNodes;
    var _$data7 = this.$data,
        treeNodes = _$data7._treeNodes,
        activeTabKey = _$data7._activeTabKey,
        searchValue = _$data7._searchValue;

    value = value || searchValue;
    var newState = {};
    this.needSyncKeys = {};
    var tabs = propTabs && propTabs.length > 0 ? propTabs : multiple && showCheckAll ? [treeNodes[0].label] : [];

    /** 搜索框输入时触发过滤 */
    var filterTreeNodeFn = filterTreeNode;
    if (filterTreeNode === false) {
      filterTreeNodeFn = function filterTreeNodeFn() {
        return true;
      };
    } else if (!filterTreeNodeFn) {
      var upperSearchValue = String(searchValue).toUpperCase();
      filterTreeNodeFn = function filterTreeNodeFn(_, node) {
        var nodeValue = String(node.label).toUpperCase();
        return nodeValue.indexOf(upperSearchValue) !== -1 && (unrelated || !node.children || node.children.length === 0);
      };
    }
    var filteredTreeNodes = null;
    if (tabs && tabs.length > 0 && treeNodes.length > 0) {
      filteredTreeNodes = [];
      tabs.forEach(function (name, index) {
        var _treeNodes$index = treeNodes[index],
            children = _treeNodes$index.children,
            rest = _objectWithoutProperties(_treeNodes$index, ['children']);

        filteredTreeNodes[index] = _extends({}, rest, {
          children: getFilterTree(children || [], value, filterTreeNodeFn)
        });
      });
      filteredTreeNodes = filteredTreeNodes.filter(function (n) {
        return n.children;
      }).length > 0 ? filteredTreeNodes : null;
    } else {
      filteredTreeNodes = getFilterTree(treeNodes, value, filterTreeNodeFn);
    }
    // console.log('searchFilter', filteredTreeNodes);

    /** 自定义过滤器点击触发过滤 */
    if (customFilterFn) {
      var searchedTreeNodes = filteredTreeNodes === null ? treeNodes : filteredTreeNodes;
      if (tabs && tabs.length > 0 && searchedTreeNodes.length > 0) {
        filteredTreeNodes = [];
        tabs.forEach(function (name, index) {
          var _searchedTreeNodes$in = searchedTreeNodes[index],
              children = _searchedTreeNodes$in.children,
              rest = _objectWithoutProperties(_searchedTreeNodes$in, ['children']);

          filteredTreeNodes[index] = _extends({}, rest, {
            children: getFilterTree(children || [], value, customFilterFn)
          });
        });
        filteredTreeNodes = filteredTreeNodes.filter(function (n) {
          return n.children;
        }).length > 0 ? filteredTreeNodes : null;
      } else {
        filteredTreeNodes = getFilterTree(searchedTreeNodes, value, customFilterFn);
      }
    }
    newState._filteredTreeNodes = filteredTreeNodes;
    // console.log('customFilter', filteredTreeNodes);

    /** 过滤后创建快速查找 */
    var fastFinderOption = [];
    var $treeNodes = filteredTreeNodes || treeNodes;

    if (showGroup) {
      if (tabs && tabs.length > 0 && $treeNodes.length > 0) {
        tabs.forEach(function (name, index) {
          var _$treeNodes$index = $treeNodes[index],
              children = _$treeNodes$index.children,
              rest = _objectWithoutProperties(_$treeNodes$index, ['children']);

          fastFinderOption[index] = _extends({}, rest, {
            children: (children || []).map(function (_ref11) {
              var value = _ref11.value,
                  label = _ref11.label;
              return { value: value, label: label };
            })
          });
        });
      } else {
        fastFinderOption = $treeNodes.map(function (_ref12) {
          var value = _ref12.value,
              label = _ref12.label;
          return { value: value, label: label };
        });
      }
      newState._fastFinderOption = fastFinderOption;
    }

    /** 重新生成节点实例`keyEntities` */
    var activeFilteredTreeNodes = [];
    var activeTreeNodes = [];
    if (tabs && tabs.length > 0) {
      tabs.forEach(function (name, index) {
        if (tabGroup === 'dimension') {
          if (index === activeTabKey) {
            if (filteredTreeNodes) {
              activeFilteredTreeNodes[index] = cloneDeep(filteredTreeNodes[index]);
            }
            activeTreeNodes[index] = treeNodes[index];
          }
        } else {
          if (filteredTreeNodes) {
            activeFilteredTreeNodes[index] = cloneDeep(filteredTreeNodes[index]);
          }
          activeTreeNodes[index] = treeNodes[index];
        }
      });
    } else {
      activeFilteredTreeNodes = cloneDeep(filteredTreeNodes);
      activeTreeNodes = treeNodes;
    }
    activeFilteredTreeNodes = activeFilteredTreeNodes && activeFilteredTreeNodes.length > 0 ? activeFilteredTreeNodes : null;
    var newTreeNodes = [].concat(_toConsumableArray(activeTreeNodes.filter(function (n, index) {
      return index === activeTabKey;
    })), _toConsumableArray(treeNodes.filter(function (n, index) {
      return index !== activeTabKey;
    })));
    var props = getOptionProps(this);

    var _convertTreeToEntitie = convertTreeToEntities(newTreeNodes, props),
        valueEntities = _convertTreeToEntitie.valueEntities;

    newState._valueEntities = Object.freeze(valueEntities);
    var activeNodes = activeFilteredTreeNodes || activeTreeNodes;
    if (showCheckedStrategy !== SHOW_CHILD) {
      activeNodes = activeTreeNodes;
    }

    var _convertTreeToEntitie2 = convertTreeToEntities(activeNodes, props),
        keyEntities = _convertTreeToEntitie2.keyEntities;

    newState._keyEntities = Object.freeze(keyEntities);
    // console.log('entitiesMap', newState);

    /** 数据量过大时执行滚动加载 */
    var length = flattenTreeNodes(tabs && tabs.length > 0 && $treeNodes[activeTabKey] ? $treeNodes[activeTabKey].children : $treeNodes).length;
    if (length > maxTreeNodes) {
      filteredTreeNodes = this._buildVisibleTreeNodes($treeNodes);
      newState._filteredTreeNodes = filteredTreeNodes;
    }

    this.setState(newState);
    this.setState(this.getDerivedState(getOptionProps(this), this.$data, { treeRefresh: true }));
  }), _defineProperty(_methods, '_buildVisibleTreeNodes', function _buildVisibleTreeNodes(data, endIndex) {
    var tabs = this.$props.tabs;
    var visibleEndIndex = this.$data._visibleEndIndex;

    var filteredTreeNodes = null;
    if (tabs && tabs.length > 1) {
      filteredTreeNodes = tabs.map(function (name, index) {
        var _data$index = data[index],
            children = _data$index.children,
            rest = _objectWithoutProperties(_data$index, ['children']);

        return _extends({}, rest, {
          children: cloneDeep((children || []).slice(0, endIndex || visibleEndIndex) || [])
        });
      });
    } else {
      filteredTreeNodes = data.slice(0, visibleEndIndex);
    }
    this.setState({ visibleEndIndex: visibleEndIndex });
    return filteredTreeNodes;
  }), _defineProperty(_methods, 'onMenuScroll', function onMenuScroll(_ref13) {
    var scrollToBottom = _ref13.scrollToBottom;
    var _$data8 = this.$data,
        visibleEndIndex = _$data8._visibleEndIndex,
        filteredTreeNodes = _$data8._filteredTreeNodes;

    if (filteredTreeNodes && scrollToBottom) {
      this.setState({ _visibleEndIndex: visibleEndIndex + 1 });

      var _$props12 = this.$props,
          defaultFilterValue = _$props12.defaultFilterValue,
          filterFn = _$props12.filterFn;

      this._buildFilteredTreeNodes(defaultFilterValue, filterFn);
    }
  }), _defineProperty(_methods, 'onFastFinderChange', function onFastFinderChange(value, fn) {
    var _this = this;

    var _$props13 = this.$props,
        defaultFilterValue = _$props13.defaultFilterValue,
        filterFn = _$props13.filterFn,
        tabs = _$props13.tabs;
    var _$data9 = this.$data,
        fastFinderOption = _$data9._fastFinderOption,
        activeTabKey = _$data9._activeTabKey,
        visibleEndIndex = _$data9._visibleEndIndex;

    var data = [];
    if (tabs && tabs.length > 0) {
      data = fastFinderOption[activeTabKey].children;
    } else {
      data = fastFinderOption;
    }

    var index = (data || []).findIndex(function (item) {
      return '' + item.value === '' + value;
    });
    if (index > -1 && index >= visibleEndIndex) {
      this.setState({ _visibleEndIndex: data.length }, function () {
        _this._buildFilteredTreeNodes(defaultFilterValue, filterFn);
        setTimeout(function () {
          fn();
          return;
        }, 400);
      });
    } else {
      fn();
    }
  }), _defineProperty(_methods, 'onPlaceholderClick', function onPlaceholderClick() {
    this.inputRef.current.focus();
  }), _defineProperty(_methods, 'scrollToTop', function scrollToTop() {
    if (this.menuRef && this.menuRef.current && this.menuRef.current.$refs.menuWrapper) {
      this.menuRef.current.$refs.menuWrapper.$el.scrollTop = 0;
    }
  }), _defineProperty(_methods, '_renderPlaceholder', function _renderPlaceholder() {
    var h = this.$createElement;

    var locale = LocaleReceiver.getLocale('Cascader', this.localeData);
    var _$props14 = this.$props,
        searchPlaceholder = _$props14.searchPlaceholder,
        prefixCls = _$props14.prefixCls;
    var searchValue = this.$data._searchValue;


    return h(
      'span',
      {
        style: {
          display: searchValue ? 'none' : 'block'
        },
        on: {
          'click': this.onPlaceholderClick
        },

        'class': prefixCls + '-search__field__placeholder'
      },
      [searchPlaceholder || locale.search]
    );
  }), _defineProperty(_methods, 'updateTreeData', function updateTreeData(treeData) {
    var _this2 = this;

    var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var _$props15 = this.$props,
        multiple = _$props15.multiple,
        showCheckAll = _$props15.showCheckAll,
        fieldNames = _$props15.fieldNames,
        tabs = _$props15.tabs;

    var defaultFields = {
      children: 'children',
      label: 'label',
      value: 'value'
    };
    var filledFieldNames = _extends({}, defaultFields, fieldNames);
    /** 兼容单tab */
    if (multiple && showCheckAll && parentKey === '' && (!tabs || tabs.length === 0)) {
      var _ref14;

      treeData = [(_ref14 = {}, _defineProperty(_ref14, filledFieldNames.label, '全部'), _defineProperty(_ref14, filledFieldNames.value, 'all'), _defineProperty(_ref14, filledFieldNames.children, treeData), _ref14)];
    }
    return (treeData || []).map(function (item) {
      var label = item[filledFieldNames.label],
          value = item[filledFieldNames.value],
          children = item[filledFieldNames.children],
          rest = _objectWithoutProperties(item, [filledFieldNames.label, filledFieldNames.value, filledFieldNames.children]);

      var treeNodeProps = _extends({}, item, {
        label: label,
        value: value,
        key: value !== undefined ? !!('' + parentKey) ? parentKey + '-' + value : '' + value : undefined,
        dataRef: item
      }, rest);
      if (children) {
        return _extends({}, treeNodeProps, { children: _this2.updateTreeData(children, treeNodeProps.key) });
      }
      return treeNodeProps;
    });
  }), _defineProperty(_methods, 'getPopupWidth', function getPopupWidth() {
    var _$props16 = this.$props,
        width = _$props16.width,
        showGroup = _$props16.showGroup,
        fastFinder = _$props16.fastFinder,
        fastFinderPos = _$props16.fastFinderPos;
    var deep = this.deep;

    var menuColumnStyle = [];
    var columnsWidth = 0;
    var w = 0;
    var loop = Math.max(deep, Array.isArray(width) ? width.length + (showGroup ? 1 : 0) : 0);
    for (var i = 0; i < loop; i++) {
      if (showGroup && i === 0) {
        w = i = 0 && deep === 1 ? width[0] : 0;
      } else if (Array.isArray(width)) {
        w = width[showGroup ? i - 1 : i] || 0;
      } else {
        w = width || 0;
      }
      w = showGroup && i === 0 ? fastFinder === 'letter' && fastFinderPos === 'left' ? 40 : fastFinder === 'dropdown' && fastFinderPos === 'left' ? 120 : 0 : w;
      columnsWidth += w;
      w = w === 0 ? 'auto' : w + 'px';
      menuColumnStyle.push({
        width: w
      });
    }

    var minWidth = width && Array.isArray(width) ? (deep - (showGroup ? 1 : 0)) * 120 : width;
    columnsWidth = columnsWidth === 0 ? 'auto' : columnsWidth;
    return {
      minWidth: minWidth,
      columnsWidth: columnsWidth,
      menuColumnStyle: menuColumnStyle
    };
  }), _defineProperty(_methods, 'getPopupPlacement', function getPopupPlacement() {
    // const { isModal } = this.$props;
    var popupPlacement = this.$props.popupPlacement;
    // if (!isModal) {
    //   const { left } = this.triggerRef.current.$el.getBoundingClientRect();
    //   const { columnsWidth } = this.getPopupWidth();
    //   const windowWidth = window.innerWidth;
    //   console.log(windowWidth - left < columnsWidth, windowWidth, left, columnsWidth)
    //   if (windowWidth - left < columnsWidth) {
    //     popupPlacement = popupPlacement.replace('Left', '').replace('Right', '') + 'Right';
    //   }
    // }

    return popupPlacement;
  }), _methods),
  render: function render() {
    var h = arguments[0];
    var $props = this.$props,
        $scopedSlots = this.$scopedSlots,
        title = this.title,
        propTabs = this.tabs,
        onMenuCheck = this.onMenuCheck,
        onMenuScroll = this.onMenuScroll,
        onItemDoubleClick = this.onItemDoubleClick,
        onCheckAllChange = this.onCheckAllChange,
        onTagRemove = this.onTagRemove,
        onTabChange = this.onTabChange,
        onDropdownVisibleChange = this.onDropdownVisibleChange,
        _buildFilteredTreeNodes = this._buildFilteredTreeNodes,
        onCancel = this.onCancel,
        onReset = this.onReset,
        onConfirm = this.onConfirm,
        deep = this.deep,
        maxDeep = this.maxDeep;
    var prefixCls = $props.prefixCls,
        multiple = $props.multiple,
        disabled = $props.disabled,
        height = $props.height,
        loading = $props.loading,
        clearIcon = $props.clearIcon,
        isModal = $props.isModal,
        showClose = $props.showClose,
        showSearch = $props.showSearch,
        searchIcon = $props.searchIcon,
        inputProps = $props.inputProps,
        showConfirm = $props.showConfirm,
        showCheckAll = $props.showCheckAll,
        showSelection = $props.showSelection,
        columnNames = $props.columnNames,
        displayRender = $props.displayRender,
        selectPrefixCls = $props.selectPrefixCls,
        inputPrefixCls = $props.inputPrefixCls,
        transitionName = $props.transitionName,
        popupClassName = $props.popupClassName,
        popupStyle = $props.popupStyle,
        popupAlign = $props.popupAlign,
        popupPlacement = $props.popupPlacement,
        builtinPlacements = $props.builtinPlacements,
        getPopupContainer = $props.getPopupContainer,
        okButtonProps = $props.okButtonProps,
        okType = $props.okType,
        cancelButtonProps = $props.cancelButtonProps,
        resetButtonProps = $props.resetButtonProps;


    var listeners = getListeners(this);

    var _$data10 = this.$data,
        sActiveValue = _$data10.sActiveValue,
        value = _$data10.sValue,
        open = _$data10._open,
        treeNodes = _$data10._treeNodes,
        activeTabKey = _$data10._activeTabKey,
        filteredTreeNodes = _$data10._filteredTreeNodes,
        fastFinderOption = _$data10._fastFinderOption,
        valueList = _$data10._valueList,
        checkedKeys = _$data10._checkedKeys,
        halfCheckedKeys = _$data10._halfCheckedKeys,
        searchValue = _$data10._searchValue,
        selectedTagList = _$data10._selectedTagList,
        selectorValueList = _$data10._selectorValueList,
        _popupPlacement = _$data10._popupPlacement;


    var activeValue = sActiveValue;
    var activeTreeNodes = treeNodes;
    var activeFilteredTreeNodes = filteredTreeNodes;
    var activeFastFinderOption = fastFinderOption;

    var tabs = propTabs && propTabs.length > 0 ? propTabs : multiple && showCheckAll && treeNodes[0] ? [treeNodes[0].label] : [];
    if (tabs && tabs.length > 0) {
      activeTreeNodes = (treeNodes[activeTabKey] || {}).children || [];
      activeFilteredTreeNodes = filteredTreeNodes ? (filteredTreeNodes[activeTabKey] || {}).children || [] : null;
      activeFastFinderOption = (fastFinderOption[activeTabKey] || {}).children || [];
      activeValue = sActiveValue.slice(1);
    }
    if (multiple) {
      activeValue = activeValue.slice(0, deep - 1);
    }

    var removeIcon = getComponentFromProp(this, 'removeIcon');
    removeIcon = Array.isArray(removeIcon) ? removeIcon[0] : removeIcon;

    var finalRemoveIcon = removeIcon && (isValidElement(removeIcon) ? cloneElement(removeIcon, { 'class': selectPrefixCls + '-remove-icon' }) : removeIcon) || h(Icon, {
      attrs: { type: 'close' },
      'class': selectPrefixCls + '-remove-icon' });

    var _getPopupWidth = this.getPopupWidth(),
        menuColumnStyle = _getPopupWidth.menuColumnStyle,
        columnsWidth = _getPopupWidth.columnsWidth,
        minWidth = _getPopupWidth.minWidth;
    /** 头部和标题 */


    var header = null;

    var finalTabs = propTabs && propTabs.length > 0 ? h(
      Tabs,
      {
        attrs: { 'active-key': activeTabKey },
        on: {
          'change': onTabChange
        }
      },
      [propTabs && propTabs.length && propTabs.map(function (name, index) {
        return h(Tabs.TabPane, { key: index, attrs: { tab: name }
        });
      })]
    ) : '';

    var closeIcon = getComponentFromProp(this, 'closeIcon');
    closeIcon = Array.isArray(closeIcon) ? closeIcon[0] : closeIcon;

    if (title || finalTabs) {
      var searchProps = {};
      if (showSearch) {
        searchProps = {
          prefixCls: inputPrefixCls,
          searchValue: searchValue,
          searchIcon: searchIcon,
          inputProps: inputProps,
          clearIcon: clearIcon,
          renderPlaceholder: this._renderPlaceholder
        };
      }
      header = h(
        'div',
        { 'class': prefixCls + '-header' },
        [h(
          'div',
          { 'class': prefixCls + '-header-title' },
          [title, finalTabs]
        ), h(
          'div',
          { 'class': prefixCls + '-header-search' },
          [h(
            'span',
            _mergeJSXProps([{
              'class': prefixCls + '-search'
            }, {
              directives: [{
                name: 'ways-ref',
                value: this.searchRef
              }]
            }]),
            [showSearch && activeTreeNodes.length > 0 && h(SearchInput, {
              props: searchProps,
              on: getListeners(this),
              directives: [{
                name: 'ways-ref',
                value: this.inputRef
              }]
            })]
          ), showClose && h(
            'span',
            {
              'class': prefixCls + '-header-close',
              on: {
                'click': function click() {
                  return onDropdownVisibleChange(false);
                }
              }
            },
            [closeIcon || h(
              'i',
              { 'class': prefixCls + '-selection__choice__remove-icon' },
              ['\xD7']
            )]
          )]
        )]
      );
    }

    /** 底部 */
    var footer = null;
    if (showConfirm) {
      var selectTagProps = {
        props: _extends({}, $props, {
          prefixCls: selectPrefixCls,
          removeIcon: finalRemoveIcon,
          choiceTransitionName: '',
          maxTagCount: 10, // 最多展示10个，超出页面的隐藏
          valueList: valueList,
          selectorValueList: selectedTagList,
          displayRender: displayRender
        }),
        on: {
          remove: onTagRemove
        }
      };
      var selectPopupProps = {
        props: _extends({}, $props, {
          builtinPlacements: _extends({}, BUILT_IN_PLACEMENTS, builtinPlacements),
          popupPlacement: 'topRight',
          transitionName: 'slide-down',
          prefixCls: selectPrefixCls,
          removeIcon: finalRemoveIcon,
          maxTagCount: undefined,
          valueList: valueList,
          selectorValueList: selectedTagList,
          height: height - 40 - (columnNames && columnNames.length > 0 ? 32 : 0),
          showType: 'list'
        }),
        on: {
          remove: onTagRemove
        }
      };

      var checkAllNode = filteredTreeNodes || treeNodes;
      var checkAllKey = 0;
      if (tabs && tabs.length > 0) {
        checkAllNode = checkAllNode[activeTabKey] || {};
        checkAllKey = checkAllNode.key;
      }
      var checkAll = checkedKeys.indexOf(checkAllKey) > -1;
      var checkboxProps = {
        props: {
          prefixCls: prefixCls,
          checked: checkAll
        }
      };
      var locale = LocaleReceiver.getLocale('Cascader', this.localeData);
      footer = h(
        'div',
        { 'class': prefixCls + '-footer' },
        [multiple && showCheckAll && h(
          'div',
          {
            'class': prefixCls + '-footer-checkall',
            on: {
              'click': function click(e) {
                return onCheckAllChange(checkAllNode, checkAll, e);
              }
            }
          },
          [h(Checkbox, checkboxProps), h('span', [locale.checkall])]
        ), showSelection && h(
          'div',
          { 'class': prefixCls + '-footer-selected ' + selectPrefixCls + '-selection--multiple' },
          [h(
            'div',
            { 'class': selectPrefixCls + '-selection__rendered' },
            [h(SelectTag, selectTagProps)]
          ), h(
            'div',
            {
              'class': prefixCls + '-footer-selected-label',
              style: { display: '' + (multiple && selectedTagList.length > 0 ? '' : 'none') }
            },
            [h(SelectPopup, selectPopupProps)]
          )]
        ), h(
          'div',
          { 'class': prefixCls + '-footer-extra-button', style: showSelection ? {} : { flex: 1 } },
          [$scopedSlots.extraButton && $scopedSlots.extraButton()]
        ), h(
          'div',
          { 'class': prefixCls + '-footer-buttons' },
          [!!$props.resetValue || h(
            Button,
            _mergeJSXProps([{
              on: {
                'click': function click() {
                  return onCancel();
                }
              },
              attrs: { size: $props.size }
            }, cancelButtonProps]),
            [getComponentFromProp(this, 'cancelText') || locale.cancelText]
          ), !!$props.resetValue && h(
            Button,
            _mergeJSXProps([{
              on: {
                'click': function click(e) {
                  return onReset(e);
                }
              },
              attrs: { size: $props.size }
            }, resetButtonProps]),
            [getComponentFromProp(this, 'resetText') || locale.resetText]
          ), h(
            Button,
            _mergeJSXProps([{
              attrs: {
                type: okType || 'primary',
                size: $props.size
              }
            }, okButtonProps, {
              on: {
                'click': onConfirm
              }
            }]),
            [getComponentFromProp(this, 'okText') || locale.okText]
          )]
        )]
      );
    }

    /** 主体内容 */
    var menus = h('div');
    var emptyMenuClassName = '';
    if (activeTreeNodes && activeTreeNodes.length > 0) {} else {
      emptyMenuClassName = ' ' + prefixCls + '-menus-empty';
    }
    var loadingIcon = getComponentFromProp(this, 'loadingIcon');
    var expandIcon = getComponentFromProp(this, 'expandIcon') || '>';
    var menuProps = {
      props: _extends({}, $props, {
        deep: deep,
        maxDeep: maxDeep,
        columnNames: columnNames && columnNames.slice(0, deep),
        activeValue: activeValue,
        value: value,
        height: height,
        minWidth: minWidth,
        menuColumnStyle: menuColumnStyle,
        treeNodes: activeTreeNodes,
        filteredTreeNodes: activeFilteredTreeNodes,
        fastFinderOption: activeFastFinderOption,
        selectorValueList: selectedTagList,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        loadingIcon: loadingIcon,
        expandIcon: expandIcon
      }),
      directives: [{
        name: 'ways-ref',
        value: this.menuRef
      }],
      on: {
        check: onMenuCheck,
        itemDoubleClick: onItemDoubleClick,
        scroll: onMenuScroll
      },
      scopedSlots: {
        filter: function filter() {
          return $scopedSlots.filter ? $scopedSlots.filter({
            searchValue: searchValue,
            buildFilteredTreeNodes: _buildFilteredTreeNodes
          }) : null;
        }
      }
    };
    menus = h(Menus, menuProps);

    /** 选择器 */
    var selectorProps = {
      props: _extends({}, $props, {
        prefixCls: selectPrefixCls,
        removeIcon: finalRemoveIcon,
        open: disabled ? false : open,
        value: selectorValueList && selectorValueList.map(function (o) {
          return o.value;
        }),
        selectorValueList: selectorValueList,
        displayRender: displayRender,
        __propsSymbol__: Symbol()
      }),
      scopedSlots: $scopedSlots
    };
    var children = filterEmpty($scopedSlots['default'] && $scopedSlots['default']());
    var selector = children.length ? children : h(Selector, selectorProps);

    /** 触发器 */
    // let stretch;
    // if (popupMatchSelectWidth !== false) {
    //   stretch = popupMatchSelectWidth ? 'width' : 'minWidth';
    // }
    var triggerProps = {
      props: {
        disabled: disabled,
        popupAlign: popupAlign,
        popupPlacement: _popupPlacement || popupPlacement,
        builtinPlacements: _extends({}, BUILT_IN_PLACEMENTS, builtinPlacements),
        popupTransitionName: transitionName,
        popupVisible: disabled ? false : open,
        getPopupContainer: getPopupContainer,
        action: disabled ? [] : ['click'],
        prefixCls: prefixCls + '-menus',
        // stretch,
        popupClassName: popupClassName + emptyMenuClassName,
        popupStyle: popupStyle
      },
      on: _extends({}, listeners, {
        popupVisibleChange: onDropdownVisibleChange
      }),
      directives: [{
        name: 'ways-ref',
        value: this.triggerRef
      }]
    };

    var popupProps = {
      props: {
        spinning: loading
      },
      directives: [{
        name: 'ways-ref',
        value: this.popupRef
      }]
    };

    var triggerContent = h(
      Spin,
      _mergeJSXProps([{
        slot: 'popup'
      }, popupProps, {
        style: {
          width: columnsWidth > 0 && maxDeep > 0 ? columnsWidth + 'px' : '100%',
          minWidth: (minWidth || 0) + 'px'
        }
      }]),
      [header, menus, footer]
    );

    return isModal ? triggerContent : h(
      Trigger,
      triggerProps,
      [selector, triggerContent]
    );
  }
};

export default SelectTrigger;